import {Component, input, output} from '@angular/core';

@Component({
  selector: 'app-confirmation-dialog',
  standalone: true,
  templateUrl: './confirmation-dialog.html',
  styleUrl: './confirmation-dialog.scss'
})
export class ConfirmationDialog {
  title = input.required<string>();
  message = input.required<string>();
  details = input<string>();
  confirmText = input.required<string>();
  cancelText = input.required<string>();
  loading = input<boolean>(false);

  onConfirm = output<void>();
  onCancel = output<void>();
}
